import React from 'react'

/* export default function  validateEmail(email) {
var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}
 */
export default function validateEmail(input) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const mobileRegex = /^[6-9]\d{9}$/; // Indian mobile: starts with 6-9, exactly 10 digits

  return emailRegex.test(input) || mobileRegex.test(input);
}
